import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import Modal from '@/common/components/Modal/index';
import { Storage } from '@/common/utils/index';
import {
  useCurrentDecedentId,
  useCurrentDecedentSections,
} from '@/app/providers/DecedentProvider';
import styles from '@/common/containers/Modals/UserGuide/styles.less';
import { Overview, EditOverview, WellDone } from '@/common/containers/Modals/UserGuide/components/index';
import cx from 'classnames';

const MODES = {
  OVERVIEW: 'overview',
  DONE: 'done',
  EDIT: 'edit',
};

const UserGuide = ({
  mode: propsMode = '',
  onModeChange,
}) => {
  const sections = useCurrentDecedentSections() || {};
  const decedentId = useCurrentDecedentId();
  const isMounted = useRef(false);
  const prevPassedState = useRef(undefined);
  const [mode, _setMode] = useState('');
  const setMode = useCallback((value) => {
    if (onModeChange) onModeChange(value);
    _setMode(value);
  }, []);

  const { immediate = {} } = sections;
  const passed = immediate.question?.passed;

  useEffect(() => {
    if (propsMode) setMode(propsMode);
  }, [propsMode, setMode]);

  useEffect(() => {
    if (!Storage.get(`guide.${decedentId}.${MODES.OVERVIEW}`)) {
      setMode(MODES.OVERVIEW);
    }
  }, [decedentId, setMode]);

  useEffect(() => {
    if (
      prevPassedState.current !== undefined &&
      !prevPassedState.current &&
      passed &&
      !Storage.get(`guide.${decedentId}.${MODES.DONE}`)
    ) {
      setMode(MODES.DONE);
    }
    prevPassedState.current = passed;
  }, [decedentId, passed, setMode]);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const Body = useMemo(() => {
    const onClose = (mode) => {
      setMode('');
      Storage.set(`guide.${decedentId}.${mode}`, '1');

      if (mode === MODES.DONE) {
        setTimeout(() => {
          if (isMounted.current) setMode(MODES.EDIT);
        }, 2000);
      }
    };

    switch (mode) {
      case MODES.OVERVIEW: {
        return <Overview onClose={() => onClose(mode)} />;
      }
      case MODES.EDIT: {
        return <EditOverview onClose={() => onClose(mode)} />;
      }
      case MODES.DONE: {
        return <WellDone onClose={() => onClose(mode)} />;
      }
      default:
        return null;
    }
  }, [decedentId, mode, setMode]);

  return (
    <Modal
      className={cx(styles.modal, mode === MODES.DONE && styles.modelWellDone)}
      open={!!mode}
      overlay
    >
      {Body}
    </Modal>
  );
};

export default UserGuide;
